module.exports = __webpack_public_path__ + "img/recognition_img.f3d1656a.png";